export default function authHeader() {
  const token = localStorage.getItem("auth-token");
  return token ? { headers: { "x-auth-token": token } } : {};
}
